import {
  changeAdaptiveState,
  showAverage,
  showCumulative,
  showMedian,
  showTrend,
} from '../utils/chart/ChartManagementFeatures/showChartFeatures';
import {
  calcTotal,
  sortCategories,
} from '../utils/chart/ChartManagementFeatures/sortChartFeatures';
import { DEFAULT_GROUP } from '../constants/common';

export const onChangeSorting = (sorting, fn, group = DEFAULT_GROUP) => {
  sortCategories(sorting, group);
  return fn(group);
};

export const toggleTrend = (e, fn, group = DEFAULT_GROUP) => {
  const show = e.target.checked;
  showTrend(show, group);
  return fn(e);
};

export const changeCumulative = (e, fn, group = DEFAULT_GROUP) => {
  const show = e?.target?.checked || false;
  showCumulative(show, group);
  return fn(e);
};

export const toggleAverage = (e, fn, group = DEFAULT_GROUP) => {
  const show = e.target.checked;
  showAverage(show, group);
  return fn(e);
};

export const toggleMedian = (e, fn, group = DEFAULT_GROUP) => {
  const show = e.target.checked;
  showMedian(show, group);
  return fn(e);
};

export const changeAdaptive = (e, fn, group = DEFAULT_GROUP) => {
  const isAdaptive = e.target.checked;
  changeAdaptiveState(isAdaptive, group);
  return fn(e);
};

export const toggleGrandTotal = (e, columnChartSorting, fn, group = DEFAULT_GROUP) => {
  const { checked } = e.target;
  calcTotal(checked, group);
  sortCategories(columnChartSorting, group);
  return fn();
};
